export const getMaxDateForStart = (date: Date | string) => {
  const endDateClone = new Date(date);
  return new Date(endDateClone.setDate(endDateClone.getDate() - 1));
};

export const getMinDateForEnd = (date: Date | string) => {
  const startDateClone = new Date(date);
  return new Date(startDateClone.setDate(startDateClone.getDate() + 1));
};

export const getEndDateOfLastWeek = (currentWeek: any, treeData: any) => {
  const { phases } = treeData;
  const currentPhase = phases[currentWeek.phaseIndex];
  const { weeks } = currentPhase;
  const lastWeek = weeks[weeks.length - 1];
  return new Date(lastWeek.endDate);
};

export const getNextPhaseStartDate = (currentWeek: any, treeData: any) => {
  const { phases } = treeData;
  const nextPhaseIndex = currentWeek.phaseIndex + 1;
  if (nextPhaseIndex <= phases.length - 1) {
    const nextPhase = phases[nextPhaseIndex];
    const startDate = new Date(nextPhase.startDate);
    return new Date(startDate.setDate(startDate.getDate() - 1));
  } else {
    return new Date(treeData.endDate);
  }
};

export const getMaxDate = (date: Date | string) => {
  let maxDate = new Date(date);
  maxDate.setDate(maxDate.getDate() - 1);
  return maxDate;
};

export const getMinDate = (date: Date | string) => {
  const newDate = new Date(date);
  let minDate = new Date(newDate.setDate(newDate.getDate() + 1));
  return minDate;
};
